import * as React from 'react';
import {networkPartnerBaseUrl, partnersBaseUrl} from "../../../../config/generals";
import {useState} from "react";
import {INetworkPartner, IPartner} from "@leap4/entities-discrepancy-common";
import {connect, ConnectedProps} from "react-redux";
import {
    AlertTypes,
    apiClient,
    DynamicDatagrid,
    Grid,
    Leap4Breadcrumbs,
    setAlert,
    MuiDataGrid,
    MuiIcons,
    Button,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions,
    MenuItem,
    Typography,
    Box,
    Toc as TocIcon
} from "@leap4/frontend";
import {Link} from "react-router-dom";
import {urlService} from "../../../routing/urlsService";
import {RootState} from "../../../../interfaces/root-state.interface";
import {useQuery} from "react-query";
import {CreateNewPartnerDialog} from "./createNewPartnerDialog";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../shared/OneOrgOnly/OneOrgOnly";

const {Assignment} = MuiIcons;
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;

//TODO: add is loading

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

interface IFormData extends Partial<IPartner> {
}


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const _AssignDemandToPartnerTable = (props: PropsFromRedux) => {
    const [data, setData] = useState<INetworkPartner[]>(null)
    const [chosenRowsIds, setChosenRowsIds] = useState(null);
    const [openDialog, setOpenDialog] = useState(false)
    const [existingPartners, setExistingPartners] = useState(null)
    const [chosenPartner, setChosenPartner] = useState(null)
    const [openCreatePartner, setOpenCreatePartner] = useState(false)
    const [entity, setInstance] = useState<IFormData>({});
    const [rows, setRows] = useState([])

    const onGetAssignPartners = async () => {
        let loadedPartners;
        loadedPartners = (await apiClient.get(partnersBaseUrl + '/demand', {params: {fields: {}}})).data
        setExistingPartners(loadedPartners)
    };

    const onGetPartners = async () => {
        const response = (await apiClient.post(`${partnersBaseUrl}/assign/demand`, data))
        setData(response.data)
        setRows(() => {
            return response.data.map(row => createRowData((row)))
        })
    }

    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'Name',
            width: 500,
            renderCell: (params: GridRenderCellParams) => {
                return (params as any).formattedValue
            }

        },
        {
            field: 'companyId',
            headerName: 'Company Id',
            width: 170,
            renderCell: (params) => {
                return (params as any).companyId
            }
        },

        {
            field: 'dataPoint',
            headerName: 'Data Point',
            width: 170,
            renderCell: (params) => {
                return <Link to={urlService.editDataPoint(params.value.id.toString())}><strong
                >{params.value.name}</strong></Link>
            }
        },

    ];

    const handleChooseRow = (chosenRows) => {
        setChosenRowsIds(chosenRows)
    }

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCancelDialog = () => {
        setOpenDialog(false);
        setOpenCreatePartner(false);
    };

    const handleAssignDialog = async () => {
        //TODO: check if there is a chosen partner and if not throw alert
        const partner = existingPartners.find(partner => partner._id.toString() === chosenPartner)
        const partnerName = partner?.name
        const partnerField = {id: chosenPartner, name: partnerName}
        const baseUrl = networkPartnerBaseUrl
        for (const rowId of chosenRowsIds as any) {
            let row = rows.find(row => row.id === rowId);
            row && await apiClient.patch(`${baseUrl}/${row.id}`, {partner: partnerField})
        }
        setOpenDialog(false);
        return getPartners()
    };

    const handleClickCreatePartner = () => {
        setOpenCreatePartner(true);
        setOpenDialog(false);
    };

    const handlePartnerSelect = (event) => {
        setChosenPartner(event.target.value);
    }

    const {isLoading: isLoadingGet, refetch: getAssignPartners} = useQuery(
        'get-partner--query',
        onGetAssignPartners,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: true,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });


    const {isLoading: isLoadingAssign, refetch: getPartners} = useQuery(
        'assign-partner--query',
        onGetPartners,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: true,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });

    function createRowData(item: INetworkPartner) {
        return {
            id: item._id,
            name: item.name,
            // side: item.side,
            companyId: item.companyId,
            dataPoint: item?.dataPoint,
            organization: item.organization
        }

    }

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <div>
                <Box
                    m={3}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    margin={1}
                >
                    <Leap4Breadcrumbs breadcrumbs={[
                        {
                            text: "Demand Partners Dashboard",
                            link: urlService.partnersDemand(),
                            icon: <TocIcon/>
                        },
                        {
                            text: "Assign Alias",
                            icon: <Assignment/>
                        }]}
                    />
                    <Button variant="outlined" size={"large"} color="primary" sx={{height: 30}}
                            onClick={handleClickOpenDialog} disabled={!chosenRowsIds?.length}>
                        Assign
                    </Button>
                </Box>
                <Dialog open={openDialog} onClose={handleCancelDialog}>
                    <DialogTitle>Assign Partners</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {`Choose A Partner from the list to be assigned to the following network partners. \n ${
                                chosenRowsIds && chosenRowsIds.map(id => rows.find(row => row.id === id)?.name)
                            }`}

                        </DialogContentText>

                        <div>
                            <TextField select name="partner" variant={"outlined"} fullWidth
                                       label={"Choose Demand Partner"}
                                       disabled={existingPartners?.length === 0} onChange={handlePartnerSelect}
                                       style={{height: "43px"}}
                            >
                                {existingPartners && !existingPartners.length ?
                                    <MenuItem value="" disabled={true}>
                                        <em>No Available Partners</em>
                                    </MenuItem> :
                                    existingPartners?.map((partner, index) => {
                                        return <MenuItem key={index} value={partner._id}>
                                            {partner.name}
                                        </MenuItem>
                                    })
                                }
                            </TextField>
                        </div>
                    </DialogContent>
                    <Grid item xs={12}>
                        <Button variant="outlined"
                                onClick={handleClickCreatePartner} >
                            Create new partner
                        </Button>
                    </Grid>
                    <DialogActions>
                        <Button onClick={handleCancelDialog}>Cancel</Button>
                        <Button onClick={handleAssignDialog}>Assign</Button>
                    </DialogActions>
                </Dialog>

                <Grid item>
                    <CreateNewPartnerDialog
                        getAssignPartners={getAssignPartners}
                        side={"demand"}
                        openCreatePartner={openCreatePartner}
                        setOpenDialog={setOpenDialog}
                        setOpenCreatePartner={setOpenCreatePartner}
                        />
                </Grid>
            </div>

            {
                <Grid container justifyContent={"space-around"} sm={12}>
                    <Grid item xs={12}>
                        <Paper elevation={5}>
                            <DynamicDatagrid rows={rows}
                                             columns={columns}
                                             loading={isLoadingAssign || isLoadingGet}
                                             loadError={false}
                                             refreshFunc={() => getPartners()}
                                             pageSize={100}
                                             style={{minHeight: `75vh`, width: '100%'}}
                                             checkboxSelection
                                             disableSelectionOnClick={true}
                                             onRowSelectionModelChange={handleChooseRow}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            }

        </>
    );
}
export const AssignDemandToPartnerTable = connector(_AssignDemandToPartnerTable)
